<template>
  <div class="config-content">
    <div v-if="isListPage">
      <div v-if="!isSearchListPage && hasNavMenuVertical" class="content-item mb12">
        <cx-check-box :value.sync="listPageShowNavMenu">显示导航</cx-check-box>
        <i class="tips-btn icon-portal-info2" @click="explainDialogClick('nav')"></i>
      </div>
      <div v-if="!isSearchListPage && hasBreadCrumbs" class="content-item mb12">
        <cx-check-box :value.sync="listPageShowBreadCrumbs">显示面包屑</cx-check-box>
        <i class="tips-btn icon-portal-info2" @click="explainDialogClick('crumbs')"></i>
      </div>
      <div v-if="!isSwiper && hasSearchComponent" class="content-item mb12">
        <cx-check-box :value.sync="listPageShowSearchComponent">显示列表页搜索</cx-check-box>
        <i class="tips-btn icon-portal-info2" @click="explainDialogClick('search')"></i>
      </div>
    </div>
    <div v-else>
      <div v-if="hasBreadCrumbs" class="content-item mb12">
        <cx-check-box :value.sync="detailPageShowBreadCrumbs">显示面包屑</cx-check-box>
        <i class="tips-btn icon-portal-info2" @click="explainDialogClick('crumbs')"></i>
      </div>
      <div v-if="hasPrevNext" class="content-item mb12">
        <cx-check-box :value.sync="detailPageShowPrevNext">显示“上一篇，下一篇”</cx-check-box>
        <i class="tips-btn icon-portal-info2" @click="explainDialogClick('prevNext')"></i>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box" v-if="explainImgSrc || explainVideoSrc">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "subPage-config",
  data() {
    return {
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      showNavMenu: true,
      showBreadCrumbs: true,
      showSearchComponent: true,
      showPrevNext: true,
      hasBreadCrumbs: false,
      hasNavMenuVertical: false,
      hasSearchComponent: false,
      hasPrevNext: false
    }
  },
  computed: {
    isListPage() {
      return this.$store.state.states.getDataPageIds.pv === "1"
    },
    isSearchListPage() {
      return this.$store.state[this.request_prefix].page?.pluginName?.indexOf("searchListPagePlugin") > -1
    },
    appId() {
      return this.$store.state.states.getDataPageIds.appId
    },
    isSwiper() {
      return !!this.$store.state.states.getDataPageIds.swiper
    },
    listPageShowNavMenu: {
      get() {
        return this.showNavMenu
      },
      set(val) {
        this.updateSubPageSetting("showNavMenu", val)
      }
    },
    listPageShowBreadCrumbs: {
      get() {
        return this.showBreadCrumbs
      },
      set(val) {
        this.updateSubPageSetting("showBreadCrumbs", val)
      }
    },
    listPageShowSearchComponent: {
      get() {
        return this.showSearchComponent
      },
      set(val) {
        this.updateSubPageSetting("showSearchComponent", val)
      }
    },
    detailPageShowBreadCrumbs: {
      get() {
        return this.showBreadCrumbs
      },
      set(val) {
        this.updateSubPageSetting("showBreadCrumbs", val)
      }
    },
    detailPageShowPrevNext: {
      get() {
        return this.showPrevNext
      },
      set(val) {
        this.updateSubPageSetting("showPrevNext", val)
      }
    }
  },
  mounted() {
    this.hasBreadCrumbs = !!sessionStorage.getItem("hasBreadCrumbs") || false
    this.hasNavMenuVertical = !!sessionStorage.getItem("hasNavMenuVertical") || false
    this.hasSearchComponent = !!sessionStorage.getItem("hasSearchComponent") || false
    this.hasPrevNext = !!sessionStorage.getItem("hasPrevNext") || false
    const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix))
    const settingPrefix = this.isListPage ? "listPageSetting" : "detailPageSetting"
    const setting = subPage[settingPrefix]
    if (this.isListPage) {
      this.showNavMenu = setting.showNavMenu
      this.showBreadCrumbs = setting.showBreadCrumbs
      this.showSearchComponent = setting.showSearchComponent
    } else {
      this.showBreadCrumbs = setting.showBreadCrumbs
      this.showPrevNext = setting.showPrevNext
    }
  },
  methods: {
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "crumbs":
          this.explainTitle = "显示面包屑"
          this.explainTips = `选择是否需要在${this.$store.state[this.request_prefix].type==='listPage'?'列表页':'详情页'}展示面包屑导航`
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/show-crumbs.mp4")
          break
        case "nav":
          this.explainTitle = "显示导航"
          this.explainTips = "选择是否需要在列表页展示数据分类导航"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/show-nav.mp4")
          break
        case "search":
          this.explainTitle = "显示列表页搜索"
          this.explainTips = "选择是否需要在列表页展示数据列表页搜索"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "prevNext":
          this.explainTitle = "显示上一篇下一篇"
          this.explainTips =
            "选择是否要在详情页上显示上一篇、下一篇，开启后可在详情页使用上一篇、下一篇翻看每一条数据的详情页"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/prevNext-img.png")
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    updateSubPageSetting(type, val) {
      this[type] = val
      const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix))
      const settingPrefix = this.isListPage ? "listPageSetting" : "detailPageSetting"
      subPage[settingPrefix][type] = val
      localStorage.setItem("subPageSetting-" + this.appId + "-" + this.request_prefix, JSON.stringify(subPage))
      const subPageEditInfo = this.$store.state.states.subPageEditInfo
      subPageEditInfo.edit = true
      subPageEditInfo.type = "setting"
      subPageEditInfo.value = type
    }
  }
}
</script>

<style scoped lang="scss">
.config-content {
  padding: 12px 12px 0 12px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.8);
  .content-item {
    display: flex;
    align-items: center;
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      margin-top: 0;
    }
  }
}
</style>
